// Require

const { id, log, percent } = require("../std/index")

const { Slice } = require("./master")


// Options

const progressStyles = {
  position: 'absolute',
  top: 0,
  left: 0,
  width: 0,
  height: '100%',
  backgroundColor: "rgba(0,0,80,0.8)",
  mixBlendMode: 'overlay'
};


//
// Blank Slice
//
// For assisting in writing slices
//

module.exports = class BlankSlice extends Slice {
  constructor($host, config) {
    super($host, config);

    this.dom.progress = $('<div></div>').css(progressStyles);
    this.dom.main.append(this.dom.progress);
  }

  onProgress(p) {
    this.dom.progress.width(percent(p % 1.00001));
  }
};
